/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable} from 'rxjs/Observable';
import { _throw } from 'rxjs/observable/throw';
/**
 * Default error handler
 */
@Injectable()
export class ErrorHandler {
  public handleError(errorResponse: HttpErrorResponse): Observable<HttpEvent<any>> {
    return _throw(errorResponse || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/sdk/services/core/error.service.ts